import { render, staticRenderFns } from "./CmgOneTapReorderDetailsModal.vue?vue&type=template&id=bb35d532&scoped=true&lang=pug&"
import script from "./cmg-one-tap-reorder-details-modal.ts?vue&type=script&lang=ts&"
export * from "./cmg-one-tap-reorder-details-modal.ts?vue&type=script&lang=ts&"
import style0 from "./CmgOneTapReorderDetailsModal.vue?vue&type=style&index=0&id=bb35d532&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb35d532",
  null
  
)

export default component.exports